import { render, staticRenderFns } from "./CardsResumoBot.vue?vue&type=template&id=62d94f91&scoped=true"
import script from "./CardsResumoBot.vue?vue&type=script&lang=js"
export * from "./CardsResumoBot.vue?vue&type=script&lang=js"
import style0 from "./CardsResumoBot.vue?vue&type=style&index=0&id=62d94f91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d94f91",
  null
  
)

export default component.exports